import React, { useState } from 'react'
import { IkonerContainerFiler } from '../../../../assets/icons'
import { CardColumn } from '../../../ui/Card/CardColumn'
import { CaseDetail } from '../../../../models/CaseDetail'
import { colors } from '../../../../theme/palette'
import CreateFileOverlay from './CreateFileOverlay'
import CaseFilesOverlay from './CaseFilesOverlay'
import { CaseFilesRowCard } from './CaseFilesRowCard'
import { L } from '../../../providers/Lokalise'

const CaseFilesRow: React.FC<{
    caseDetails: CaseDetail
    onUpdated: () => void
}> = ({ caseDetails, onUpdated }) => {
    const [showAllFiles] = useState(false)

    return (
        <CardColumn
            titleLabel={L('LØN_SAGS_FILER_CONTAINER_TITEL')}
            titleIcon={<IkonerContainerFiler fill={colors.green500} />}
            rows={[
                {
                    label: '',
                    value: '',
                    useContent: true,
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.7rem',
                                overflow: 'hidden',
                                width: '100%',
                            }}
                        >
                            <CreateFileOverlay
                                caseDetails={caseDetails}
                                onUpdated={onUpdated}
                            />
                            <div style={{ position: 'relative' }}>
                                {caseDetails?.fileList
                                    ?.slice(0, showAllFiles ? undefined : 4)
                                    .map((file, index) => (
                                        <div
                                            key={file.fullName}
                                            style={{
                                                marginBottom: '.7rem',
                                                opacity:
                                                    !showAllFiles && index === 3
                                                        ? 0.3
                                                        : 1,
                                                position: 'relative',
                                                ...(index === 3 &&
                                                    !showAllFiles && {
                                                        maxHeight: '2.5rem',
                                                        overflow: 'hidden',
                                                        background:
                                                            'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.3) 100%)',
                                                    }),
                                            }}
                                        >
                                            <CaseFilesRowCard
                                                file={file}
                                                onUpdated={onUpdated}
                                                caseDetails={caseDetails}
                                            />
                                        </div>
                                    ))}
                            </div>
                            {caseDetails?.fileList?.length > 3 && (
                                <div
                                    style={{
                                        position: 'relative',
                                        zIndex: 2,
                                        backgroundColor: 'white',
                                        top: '-.8rem',
                                        width: '100%',
                                    }}
                                >
                                    <CaseFilesOverlay
                                        caseDetails={caseDetails}
                                        onUpdated={onUpdated}
                                        files={caseDetails?.fileList}
                                    />
                                </div>
                            )}
                        </div>
                    ),
                },
            ]}
        />
    )
}

export { CaseFilesRow }
